(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('kb-editorial')) {
    customElements.define('kb-editorial', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.motion !== 'true' || window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) return;
        this.classList.add('is-pending');
        this.observer = new IntersectionObserver(entries => {
          if (!entries.some(entry => entry.isIntersecting)) return;
          this.classList.remove('is-pending');
          this.classList.add('is-revealing');
          this.observer.disconnect();
          this.revealTimer = setTimeout(() => this.classList.remove('is-revealing'), 2600);
        }, { threshold: .12 });
        this.observer.observe(this);
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        clearTimeout(this.revealTimer);
        this.classList.remove('is-pending', 'is-revealing');
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zf-video-banner"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('zf-video-banner'))customElements.define('zf-video-banner',class extends HTMLElement{
connectedCallback(){if(this.abort)return;this.abort=new AbortController();const signal=this.abort.signal,video=this.querySelector('video'),button=this.querySelector('button');if(!video||!button)return;const sync=()=>{const paused=video.paused;button.querySelector('[data-play-label]').hidden=!paused;button.querySelector('[data-pause-label]').hidden=paused;button.setAttribute('aria-label',button.querySelector(paused?'[data-play-label]':'[data-pause-label]').textContent)};video.addEventListener('play',sync,{signal});video.addEventListener('pause',sync,{signal});button.addEventListener('click',()=>{if(video.paused)video.play().catch(sync);else video.pause()},{signal});video.muted=true;if(matchMedia('(prefers-reduced-motion: reduce)').matches)video.pause();else video.play().catch(sync);sync()}
disconnectedCallback(){this.abort?.abort();this.abort=null}
});

  } catch(e) { console.error(e); }
})();
})();
